<script>
import { defineComponent, h, resolveComponent } from 'vue'

export default defineComponent({
  name: 'Air8DynamicText',
  aliasName: 'a8-d-text',

  inheritAttrs: false,

  render () {
    return h(resolveComponent('a-input'), this.$attrs, this.$slots)
  }
})
</script>
